<template>
  <div class="content-grid content-grid--subpage">
    <Breadcrumbs :title="t(`routes.admin.children.organizations.addMember.name`)" />
    <BackLinkTitle :title="t(`routes.admin.children.organizations.addMember.name`)" />
    <Card>
        <MemberForm v-if="organization" :is-syndicate-organization="organization?.type === OrganizationType.RegularSyndicate"
                    @formSubmit="handleSubmit" />
        <Loader v-else :is-inline="true" />
    </Card>
  </div>
</template>

<script lang="ts" setup>
import {useI18n} from "vue3-i18n";
import {useRouter} from "vue-router";
import {useMemberService, useOrganizationService} from "@/inversify.config";
import {notifyError, notifySuccess} from "@/notify";
import {Member} from "@/types/entities/member";
import {IAddMemberRequest} from "@/types/requests/addMemberRequest";
import Breadcrumbs from "@/components/layout/Breadcrumbs.vue";
import BackLinkTitle from "@/components/layout/BackLinkTitle.vue";
import Card from "@/components/layout/Card.vue";
import MemberForm from "@/components/forms/MemberForm.vue";
import {useMemberStore} from "@/stores/memberStore";
import {OrganizationType, Role} from "@/types";
import {onMounted, ref} from "vue";
import {IFullOrganization} from "@/types/entities/organization";
import Loader from "@/components/layout/Loader.vue";

// eslint-disable-next-line no-undef
const props = defineProps<{
    organizationId: string;
}>();

const { t, getLocale } = useI18n()
const router = useRouter();
const memberStore = useMemberStore()
const memberService = useMemberService()
const organizationService = useOrganizationService()

let organization = ref<IFullOrganization>()

onMounted(async () => {
  organization.value = memberStore.hasRole(Role.Admin)
      ? await organizationService.getOrganizationWithId(props.organizationId)
      : await organizationService.getMyOrganization(getLocale())
})

async function handleSubmit(member : Member) {
    let succeededOrNotResponse = await memberService.addMember(member as IAddMemberRequest, props.organizationId)
    if (succeededOrNotResponse && succeededOrNotResponse.succeeded) {
        notifySuccess(t('validation.member.add.success'))
        setTimeout(() => {
            router.back();
        }, 1500);
    } else {
        let errorMessages = succeededOrNotResponse.getErrorMessages('validation.member.add');
        if (errorMessages.length == 0)
          notifyError(t('validation.member.add.errorOccurred'))
        else
          notifyError(errorMessages[0])
    }
}
</script>
